import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import CollectionDetailActions from './CollectionDetailActions';
import CollectionDetailContent from './CollectionDetailContent';
import CollectionDetailHeader from './CollectionDetailHeader';
import CollectionDetailNotes from './CollectionDetailNotes';
import CollectionDetailSharing from './CollectionDetailSharing';
import ContentOwnership from '../ContentOwnership'
import SidebarDetailHeader from '../SidebarDetailHeader';
import styles from './Collection.module.scss'
import Loader from '../../Loader';
function CollectionSidebar(props) {
  return (
    <>
      {props.selectedCollectionLoading ? (
        <div className={styles.loader}>
          <Loader active={true} />
          {props.loadingText}
        </div>
      ) : (
        <>
          <SidebarDetailHeader />
          <CollectionDetailHeader />
          <CollectionDetailActions />
          <CollectionDetailSharing />
          {!props.selectedCollection.isOwner ? <ContentOwnership sharedBy={props.selectedCollection.sharedBy} type={'Hunt'} /> : null}
          <CollectionDetailNotes />
          <CollectionDetailContent />
        </>
      )}
    </>
  );
}

CollectionSidebar.propTypes = {
  loadingText: PropTypes.string,
  selectedCollection: PropTypes.object,
  selectedCollectionLoading: PropTypes.bool,
};

export default connect((model) => {
  const { selectedCollection, selectedCollectionLoading } = model.collections
  let loadingText = 'Loading hunt...'
  return {
    loadingText,
    selectedCollection,
    selectedCollectionLoading
  };
})(CollectionSidebar);
